module.exports = __webpack_public_path__ + "img/light-touch-clinic-social-media-videography.f7cf3489.jpg";